<template>
  <div class="pl-toolbar-actions" aria-label="Callers actions">
    <div class="pl-toolbar-actions__stats" role="list">
      <div class="pl-chip" role="listitem">
        <v-icon icon="mdi-account-voice" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value">{{ totalCallers }}</span>
        <span class="pl-chip__label">Callers</span>
      </div>

      <div class="pl-chip" role="listitem">
        <v-icon icon="mdi-phone-log" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value pl-chip__value--mono">{{ callsDisplay }}</span>
        <span class="pl-chip__label">Calls</span>
      </div>

      <div v-if="isSearchActive" class="pl-chip pl-chip--accent" role="listitem">
        <v-icon icon="mdi-magnify" class="pl-chip__icon" size="16" />
        <span class="pl-chip__value">Filtered</span>
      </div>
    </div>

    <div class="pl-toolbar-actions__buttons">
      <v-btn
        variant="flat"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--primary"
        prepend-icon="mdi-plus"
        :disabled="!isSessionReady"
        @click="$emit('add')"
      >
        Add Caller
      </v-btn>

      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-file-upload-outline"
        :disabled="!isSessionReady"
        @click="$emit('bulk-upload')"
      >
        Bulk Upload
      </v-btn>

      <v-btn
        variant="outlined"
        size="small"
        class="pl-toolbar-btn pl-toolbar-btn--ghost"
        prepend-icon="mdi-refresh"
        :loading="loading"
        :disabled="!isSessionReady"
        @click="$emit('refresh')"
      >
        Refresh
      </v-btn>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { formatNumber } from '@/utils/format'

defineOptions({ name: 'CallersHeader' })

const props = defineProps({
  totalCallers: { type: Number, default: 0 },
  totalCalls: { type: Number, default: 0 },
  loading: { type: Boolean, default: false },
  isSessionReady: { type: Boolean, default: false },
  isSearchActive: { type: Boolean, default: false },
})

defineEmits(['add', 'refresh', 'bulk-upload'])

const callsDisplay = computed(() => formatNumber(props.totalCalls))
</script>
